/**
 * Human-readable CIID summary for admin user detail.
 * @param {number|null|undefined} contentId
 * @param {string|null|undefined} contentType
 * @returns {{ hasCiid: boolean, contentId: string, contentType: string }}
 */
export function formatCiidDisplay (contentId, contentType) {
  const hasId = contentId != null && contentId !== ''
  const hasType = contentType != null && String(contentType).trim() !== ''
  const hasCiid = hasId || hasType
  return {
    hasCiid,
    contentId: hasId ? String(contentId) : '—',
    contentType: hasType ? String(contentType) : '—',
  }
}
